(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cod-whatsapp-confirmation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cod-whatsapp-confirmation')) {
    class CodWhatsappConfirmation extends HTMLElement {
      connectedCallback() {
        this.checkbox = this.querySelector('.tae-cod-confirmation__checkbox');
        this.form = this.checkbox ? document.getElementById(this.checkbox.getAttribute('form')) : null;
        if (!this.checkbox || !this.form) return;

        this.handleSubmit = this.handleSubmit.bind(this);
        this.form.addEventListener('submit', this.handleSubmit);
      }

      disconnectedCallback() {
        if (!this.checkbox || !this.form) return;
        this.form.removeEventListener('submit', this.handleSubmit);
      }

      handleSubmit() {
        if (this.checkbox.checked && window.clarity) {
          window.clarity('event', 'tae_cod_whatsapp_consent');
        }
      }
    }

    customElements.define('cod-whatsapp-confirmation', CodWhatsappConfirmation);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tae-clarity-context"] && !Shopify.designMode) return;
  try {
    (function () {
    var context = document.querySelector('[data-tae-clarity-context]');
    if (!context) return;

    var params = new URLSearchParams(window.location.search);
    var names = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
    var tags = {
      page_type: context.dataset.pageType || 'other',
      product_handle: context.dataset.productHandle || 'none',
      meta_click: params.has('fbclid') ? 'yes' : 'no'
    };

    names.forEach(function (name) {
      var value = params.get(name);
      if (value) {
        sessionStorage.setItem('tae_' + name, value);
      } else {
        value = sessionStorage.getItem('tae_' + name);
      }
      if (value) tags[name] = value.slice(0, 120);
    });

    var attempts = 0;
    var applyTags = function () {
      attempts += 1;
      if (window.clarity) {
        Object.keys(tags).forEach(function (name) {
          window.clarity('set', name, tags[name]);
        });
        return;
      }
      if (attempts < 20) setTimeout(applyTags, 250);
    };

    applyTags();
  })();
  } catch(e) { console.error(e); }
})();

})();
